import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD__ml_asset_t2i_adapter } from '../../../_fields/ml_asset/guidance/FIELD__ml_asset_t2i_adapter';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_type } from '../../_base/ENUM__invocation_type';
import { INVOCATION_SD__denoise_latents_pipeline } from '../denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__base } from '../INVOCATION_SD__base';

export class INVOCATION_SD__t2i_adapter extends INVOCATION_SD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_SD__T2I_ADAPTER;

  /*
   * INPUTS
   */

  @FIELD__ml_asset_t2i_adapter.init_as_input()
  t2i_adapter!: FIELD__ml_asset_t2i_adapter;

  /*
   * OUTPUTS
   */

  /*
   * EVENTS
   */

  edges__try_autocreate(graph: DTO_GRAPH__instance) {
    super.edges__try_autocreate(graph);

    let nodes_denoise = graph.nodes__get_by_type(INVOCATION_SD__denoise_latents_pipeline);

    if (nodes_denoise.length != 1) return;

    /*
     * INVOCATION_SD__t2i_adapter -> INVOCATION_SD__denoise_latents_pipeline
     */
    this.edges__try_autocreate_from_left_to_right_one_field(graph, INVOCATION_SD__denoise_latents_pipeline, ['t2i_adapter'], this.t2i_adapter, false);
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.SD__T2I_ADAPTER);
  }
}
